import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const CloseOrdersForWeek = () => {
  const [openMenus, setOpenMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { token } = useAuth();

  const authHeaders = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchOpenMenus = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('https://api.reshipesbakery.com/reshipes/getOpenMenus', { headers: authHeaders });
      if (res.ok) setOpenMenus(await res.json());
    } catch {}
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchOpenMenus(); }, [token]);

  const handleClose = async (menuType) => {
    setError(null);
    setSuccess(null);
    try {
      const res = await fetch(
        `https://api.reshipesbakery.com/reshipes/turnOffOrders?menuType=${encodeURIComponent(menuType)}`,
        { method: 'POST', headers: authHeaders }
      );
      if (!res.ok) throw new Error('Failed to close menu');
      setSuccess(`${menuType} has been closed.`);
      fetchOpenMenus();
    } catch (e) {
      setError(e.message);
    }
  };

  const handleCloseAll = async () => {
    setError(null);
    setSuccess(null);
    try {
      const res = await fetch('https://api.reshipesbakery.com/reshipes/turnOffOrders', {
        method: 'POST', headers: authHeaders,
      });
      if (!res.ok) throw new Error('Failed to close all menus');
      setSuccess('All menus have been closed.');
      fetchOpenMenus();
    } catch (e) {
      setError(e.message);
    }
  };

  if (loading) return <div className="container mt-5">Loading…</div>;

  return (
    <div className="container mt-5" style={{ maxWidth: 600 }}>
      <h1>Close Order Forms</h1>

      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {success && <div className="alert alert-success mt-3">{success}</div>}

      {openMenus.length === 0 ? (
        <p className="mt-4 text-muted">No menus are currently open.</p>
      ) : (
        <>
          {openMenus.map(menu => (
            <div key={menu.id} className="card mb-3 mt-4">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1">{menu.menuType}</h5>
                  <span className="text-muted" style={{ fontSize: '0.88rem' }}>
                    {menu.startDate && menu.endDate
                      ? `${menu.startDate} – ${menu.endDate}`
                      : 'No date range'}
                  </span>
                </div>
                <button className="btn btn-danger" onClick={() => handleClose(menu.menuType)}>
                  Close
                </button>
              </div>
            </div>
          ))}
          {openMenus.length > 1 && (
            <button className="btn btn-outline-danger mt-2" onClick={handleCloseAll}>
              Close All Menus
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default CloseOrdersForWeek;
